import defaultColor from "@/components/color";
import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'
let op = JSON.parse(JSON.stringify(cpt_chart_column_option))

export default {
    attribute: {
        chartTitle: '', titleLeft: 'center', titleTop: '10', titleTextColor: '#ccc',
        xAxisShow: false, xLineShow: true, titleSize: 18, yLabelSize: 13,
        xLabelColor: '#6aa9e4', xLineColor: '#02438e', yLabelColor: op.attribute.xAxis.axisLine.lineStyle.color,
        yGridLineShow: false, yTickShow: true, xTickShow: true, xGridLineShow: false,
        barBorderRadius: 5, barLabelShow: false, barBgShow: true,
        barLabelColor: '#ccc', barLabelSize: 10, barLabelPosition: 'right', barLabelUnit: '',
        barColor: [defaultColor[0], defaultColor[1]], barWidth: 8, sort: 'desc',
        gridX: 10, gridY: 30, gridX2: 40, gridY2: 0,
        enableScroll: true, showLine: 5, scrollType: 'one', scrollTime: 3,
        tooltip: op.attribute.tooltip,
        cptTableData: [{ "name": "维度", "value": "", "namekey": "name" },{ "name": "指标", "value": "", "namekey": "value" }]
     },
    cptDataForm: {
        dataText: '[{"name":"Mon","value":120},{"name":"Tue","value":200},{"name":"Wed","value":150},{"name":"Thu","value":80},{"name":"Fri","value":70},{"name":"Sat","value":110},{"name":"Sun","value":130},{"name":"Test","value":250}]',
        dataSource: 1, pollTime: 0
    },
}